import { API, graphqlOperation } from 'aws-amplify';
import store from '../store';

import Documents from './queries';

const initialState = {
  documents: [],
  loading: false,
  error: '',
  applicantId: '',
  minUcComment: '',
  idProofComment: '',
  rentalBaseComment: '',
  rentalAgreementComment: '',
  incomeBaseComment: '',
  minUcStatus: null,
  idProofStatus: null,
  rentalBaseStatus: null,
  rentalAgreementStatus: null,
  incomeBaseStatus: null,
};

export const documentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCHING_DOCUMENTS':
      return { ...state, loading: true };
    case 'RECEIVED_DOCUMENTS':
      return {
        ...state,
        loading: false,
        documents: action.documents,
      };
    case 'FETCH_DOCUMENTS_ERROR':
      return { ...state, error: action.error, loading: false };
    case 'RECEIVED_APPLICANT':
      return { ...state, applicantId: action.propositionID };
    case 'CLEAR_ERROR_MESSAGE':
      return { ...state, error: '' };
    case 'RECEIVE_DOCUMENT_CATEGORY_COMMENTS':
      return {
        ...state,
        minUcComment: action.comments.minUcComment.comment,
        minUcStatus: action.comments.minUcComment.status,
        idProofComment: action.comments.idProofComment.comment,
        idProofStatus: action.comments.idProofComment.status,
        rentalBaseComment: action.comments.rentalBaseComment.comment,
        rentalBaseStatus: action.comments.rentalBaseComment.status,
        rentalAgreementComment: action.comments.rentalAgreementComment.comment,
        rentalAgreementStatus: action.comments.rentalAgreementComment.status,
        incomeBaseComment: action.comments.incomeBaseComment.comment,
        incomeBaseStatus: action.comments.incomeBaseComment.status,
      };
    default:
      return state;
  }
};

const startFetchDocuments = () => dispatch => {
  dispatch({
    type: 'FETCHING_DOCUMENTS',
  });
};
const errorFetchDocuments = err => {
  // TODO: Redirect to login if error is "not authenticated"
  let error = err.errors[0].message;

  if (typeof error !== 'string') {
    error = 'Något gick fel';
  }
  return dispatch => {
    dispatch({ type: 'FETCH_DOCUMENTS_ERROR', error });
  };
};

export const getDocuments = () => dispatch => {
  const { propositionID } = store.getState().app;

  dispatch(startFetchDocuments());
  API.graphql(graphqlOperation(Documents(propositionID)))
    .then(({ data: { documents } }) => {
      dispatch({
        type: 'RECEIVED_DOCUMENTS',
        documents,
      });
    })
    .catch(err => {
      dispatch(errorFetchDocuments(err));
    });
};

export const getApplicantId = () => dispatch => {
  const { propositionID } = store.getState().app;

  dispatch({
    type: 'RECEIVED_APPLICANT',
    propositionID,
  });
};

export default documentsReducer;



// WEBPACK FOOTER //
// ./src/features/FileHandler/reducer.js